import React from 'react';

interface HomeScreenProps {
  games: any[];
  promotions: any[];
  gamesLoading: boolean;
  gameFilter: string;
  gameSearch: string;
  onSetGameFilter: (cat: string) => void;
  onPlayGame: (url: string) => void;
}

export const HomeScreen: React.FC<HomeScreenProps> = ({
  games,
  promotions,
  gamesLoading,
  gameFilter,
  gameSearch,
  onSetGameFilter,
  onPlayGame,
}) => {
  const getFilteredGamesList = () => {
    return games.filter((g) => {
      const matchSearch = g.name.toLowerCase().includes(gameSearch.toLowerCase());
      if (gameFilter === 'All') return matchSearch && g.status === 'active';
      return matchSearch && g.status === 'active' && g.category === gameFilter;
    });
  };

  const getAssetUrl = (path?: string) => {
    if (!path) return '/logo.png';
    if (path.startsWith('http')) return path;
    return path;
  };

  return (
    <div className="pwa-tab-scroll">
      {/* Promotions Gradient Carousel */}
      {promotions.length > 0 && (
        <div className="pwa-promo-wrapper">
          {promotions.map((promo, idx) => (
            <div
              key={promo.id || idx}
              className={`pwa-promo-card ${idx % 2 === 0 ? 'pwa-gradient-1' : 'pwa-gradient-2'}`}
            >
              <div className="pwa-promo-tag">{promo.tag || 'PROMO'}</div>
              <div className="pwa-promo-title">{promo.title}</div>
              <div className="pwa-promo-desc">{promo.description}</div>
            </div>
          ))}
        </div>
      )}

      {/* Category Chips */}
      <div className="pwa-chip-row">
        {['All', 'Action', 'Arcade', 'Cards'].map((cat) => (
          <button
            key={cat}
            onClick={() => onSetGameFilter(cat)}
            className={`pwa-chip ${gameFilter === cat ? 'pwa-chip-active' : ''}`}
          >
            {cat}
          </button>
        ))}
      </div>

      {/* Games Grid */}
      <div className="pwa-section-header">FEATURED GAMES</div>
      {gamesLoading ? (
        <div style={{ textAlign: 'center', padding: '30px', color: '#8B5CF6' }}>Loading games...</div>
      ) : (
        <div className="pwa-games-grid">
          {getFilteredGamesList().map((game) => (
            <div key={game.id} className="pwa-game-card">
              <img
                src={getAssetUrl(game.logo)}
                alt={game.name}
                className="pwa-game-cover"
                onError={(e) => {
                  (e.target as HTMLElement).setAttribute('src', '/icons/icon-192.png');
                }}
              />
              <div className="pwa-game-meta">
                <div className="pwa-game-name">{game.name}</div>
                <button
                  onClick={() => onPlayGame(game.url)}
                  className="pwa-play-btn"
                >
                  PLAY NOW
                </button>
              </div>
            </div>
          ))}
          {getFilteredGamesList().length === 0 && (
            <div style={{ gridColumn: 'span 2', textAlign: 'center', color: 'rgba(255,255,255,0.4)', padding: '24px 0', fontSize: '13px' }}>
              No games found.
            </div>
          )}
        </div>
      )}
    </div>
  );
};
